/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelEnvelopeReviewCompletionIn } from '../models/ChannelEnvelopeReviewCompletionIn';
import type { ChannelEnvelopeReviewOut } from '../models/ChannelEnvelopeReviewOut';
import type { ChannelEnvelopeReviewResetIn } from '../models/ChannelEnvelopeReviewResetIn';
import type { ChannelEnvelopeReviewSaveIn } from '../models/ChannelEnvelopeReviewSaveIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChannelEnvelopeReviewService {
    /**
     * Get Review
     * @returns ChannelEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static getReviewProjectsProjectIdChannelEnvelopesFilesFileIdReviewGet({
        projectId,
        fileId,
    }: {
        projectId: number,
        fileId: string,
    }): CancelablePromise<ChannelEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/channel-envelopes/files/{file_id}/review',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Review
     * @returns ChannelEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static saveReviewProjectsProjectIdChannelEnvelopesFilesFileIdReviewPut({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: ChannelEnvelopeReviewSaveIn,
    }): CancelablePromise<ChannelEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/channel-envelopes/files/{file_id}/review',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Review Completion
     * @returns ChannelEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static setReviewCompletionProjectsProjectIdChannelEnvelopesFilesFileIdReviewCompletionPut({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: ChannelEnvelopeReviewCompletionIn,
    }): CancelablePromise<ChannelEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/channel-envelopes/files/{file_id}/review/completion',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Review
     * @returns ChannelEnvelopeReviewOut Successful Response
     * @throws ApiError
     */
    public static resetReviewProjectsProjectIdChannelEnvelopesFilesFileIdReviewResetPost({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: ChannelEnvelopeReviewResetIn,
    }): CancelablePromise<ChannelEnvelopeReviewOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/channel-envelopes/files/{file_id}/review/reset',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
